import Image from 'next/image';

import { Button, Col, Container, Row, Typography } from 'darrius';

import { Header } from '../../components/atoms';

import { imgPrefix } from '../../utils/imgPrefix';

import { HeadContent } from '../../components';

import styles from './ErrorTemplate.module.scss';

interface IErrorTemplateProps {
  title: string;
  text: string;
}

export function ErrorTemplate({ title, text }: IErrorTemplateProps) {
  return (
    <>
      <HeadContent
        metaTitle="GetNinjas | Problemas Técnicos"
        metaDescription="Problemas Técnicos"
        slug="Problemas Técnicos"
        type="pages:error"
        noindex
      />

      <Container>
        <Header.Simple />

        <Row className={styles['error-content']}>
          <Col className="col-sm-12">
            <Image
              src={imgPrefix(
                '/images/serverSideError/server-side-error-off.svg'
              )}
              alt="Serviço não encontrado"
              width={276}
              height={276}
              className="responsive-image"
            />
          </Col>

          <Col className="col-sm-12 col-md-6 start-sm">
            <Typography.Title size="3xl">alguma coisa</Typography.Title>
            <Typography.Text>alguma coisa</Typography.Text>
          </Col>

          <Col className="col-sm-12 col-md-6 start-sm">
            <Button.Link
              size="small"
              href="/?utm_source=error-page&utm_medium=button"
            >
              Voltar para a página inicial
            </Button.Link>
          </Col>
        </Row>
      </Container>
    </>
  );
}
